import { Avatar, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { TherapySearch } from 'Images';

export const Title = () => {
  return (
    <>
      <Typography component={'h1'} variant='h3' color={'secondary'}>
        {Dictionary[DICTIONARY.Suppliers].therapySearchForm.title}
      </Typography>
      <Avatar
        src={TherapySearch}
        alt={''}
        sx={{ height: '110px', width: '254.66px' }}
      />
    </>
  );
};
